<template>
  <el-tag :type="type">{{ label }}</el-tag>
</template>
<script setup>
/* eslint-disable no-undef */ import { computed } from 'vue'
const props = defineProps({ status: { type: String, default: '' } })
const map = {
  DRAFT: ['warning', '草稿'],
  CONFIRMED: ['success', '已确认'],
  VOID: ['info', '已作废'],
  OPEN: ['warning', '待发放'],
  PAID: ['success', '已发放'],
  LEGACY: ['info', '历史快照'],
  ACTIVE: ['success', '已启用'],
  DISABLED: ['info', '已停用'],
  CLOSED: ['success', '已结账'],
  REOPENED: ['warning', '已反结账'],
  PENDING: ['warning', '待处理'],
  COMPLETED: ['success', '已完成'],
  UNDER_REVIEW: ['warning', '审核中'],
  REVIEW_FAILED: ['danger', '审核未通过'],
  APPROVED: ['success', '审核通过'],
}
const type = computed(() => map[props.status]?.[0] || 'info')
const label = computed(() => map[props.status]?.[1] || props.status || '未知')
</script>
